import { Flex, Image } from "@chakra-ui/react";
import React from "react";
import { useQuery } from "react-query";
import { imagesApiClient } from "../../apiConfig";
import MotionDiv from "../../common/MotionDiv";
import { useApiUser } from "../../context/ApiAuthContext";
import Loader from "../Loader";

const CustomerLogo = () => {
  const user = useApiUser();
  const { customerId, customerName, tenantId } = user;
  const { isLoading, isError, data } = useQuery("company_logo", () =>
    imagesApiClient.userApiImagesEncodedIdGet(
      `${customerId}_logo`,
      "",
      undefined,
      tenantId,
      "1.0",
      "en-US,en"
    )
  );
  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return null;
  }
  return (
    <Flex
      layerStyle={"kioskBarcodeLayout.Logo"}
      justifyContent={"center"}
      alignItems={{ base: "end", sm: "center" }}
      h={"full"}
      w={"full"}
      flex={1}
      overflow={"hidden"}
    >
      <MotionDiv
        h={"full"}
        w={"full"}
        flex={1}
        justifyContent={"center"}
        alignItems={"center"}
        display={"flex"}
        animate={{
          x: [-420, 0],
          opacity: [0, 1],
        }}
        key={"logo"}
        transition={{
          duration: 0.5,
          ease: "easeInOut",
        }}
      >
        <Image
          src={data.data}
          alt={customerName}
          objectFit="contain"
          data-testid={"customer-logo"}
          // p={[10, 24, 32, 36, 48]}
          //       w={["100px", "300px"]}
          h={"full"}
          maxW={{ base: "50vw", sm: "40vw" }}
          maxH={"40vh"}
        />
      </MotionDiv>
    </Flex>
  );
};

export default CustomerLogo;
